import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import styled  from 'styled-components';
import Background from './components/background.component';
import NavBar from './components/navbar.component';
import Footer from './components/footer.component';
import Imprint from './components/imprint.component';
import Privacy from './components/privacy.component';
import Statutes from './components/statutes.component';
import Join from './components/join.component';
import Board from './components/board.component';
import Club from './components/club.component';
import News from './components/news.component';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import scrollUp from './images/scrollUp.png';


const MarginTop = styled.div`
    margin-top:50px;
`;

class App extends Component {
  render() {
    return (
      <div>
        <Background key="backgroundComponent" />
        <HashRouter>
          <div>
            <div id="main" className="container-fluid">
                <div id="content">
                  <NavBar key="navbarComponent" />
                  <MarginTop>
                    <Route exact={true} path="/" component={Club}/>
                    <Route exact={true} path="/impressum" component={Imprint}/>
                    <Route exact={true} path="/datenschutz" component={Privacy}/>
                    <Route exact={true} path="/satzung" component={Statutes}/>
                    <Route exact={true} path="/beitreten" component={Join}/>7
                    <Route exact={true} path="/vorstand" component={Board}/>
                    <Route exact={true} path="/neuigkeiten" component={News}/>
                  </MarginTop>
                </div>
            </div>
            <Footer key="footerComponent" />
          </div>
        </HashRouter>
        <ScrollToTop showUnder={160}>
          <img src={scrollUp} alt="" className="bg-light rounded-circle" />
        </ScrollToTop>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js